import type { CatalogResponse, BriefingResponse } from '../../types';

// Per-catalog entity terminology (SC-2191). The BE sets these from
// `CatalogProfile.entity_term_*` so a catalog of athletes renders as
// "athletes", a catalog of products renders as "products", etc. The BE
// supplies "product"/"products" defaults for legacy/unprofiled catalogs.
//
// The FE-side default handles the chat input placeholder case where no
// catalog is in scope. `||` rather than `??` also catches an empty string
// (defense-in-depth) — meaningless display copy.
type EntityTermSource =
  | Pick<CatalogResponse, 'entity_term_singular' | 'entity_term_plural'>
  | Pick<BriefingResponse['catalog'], 'entity_term_singular' | 'entity_term_plural'>;

export function entityPlural(source: EntityTermSource | null | undefined): string {
  return source?.entity_term_plural || 'products';
}

export function entitySingular(source: EntityTermSource | null | undefined): string {
  return source?.entity_term_singular || 'product';
}
